
import { singleton, concat, map, empty, iterate } from "../fable-library-js.5.0.0-rc.2/List.js";
import { singleton as singleton_1 } from "../fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { Timer_delay } from "./prelude.fs.js";
import { startImmediate } from "../fable-library-js.5.0.0-rc.2/Async.js";

/**
 * Execute the commands using the supplied dispatcher
 */
export function Cmd_exec(onError, dispatch, cmd) {
    iterate((call) => {
        try {
            call(dispatch);
        }
        catch (ex) {
            onError(ex);
        }
    }, cmd);
}

/**
 * None - no commands, also known as `[]`
 */
export function Cmd_none() {
    return empty();
}

/**
 * When emitting the message, map to another type
 */
export function Cmd_map(f, cmd) {
    return map((g) => ((arg_1) => {
        g((arg) => {
            arg_1(f(arg));
        });
    }), cmd);
}

/**
 * Aggregate multiple commands
 */
export function Cmd_batch(cmds) {
    return concat(cmds);
}

/**
 * Command to call the effect
 */
export function Cmd_ofEffect(effect) {
    return singleton(effect);
}

/**
 * Command to evaluate a simple function and map the result
 * into success or error (of exception)
 */
export function Cmd_OfFunc_either(task, arg, ofSuccess, ofError) {
    return singleton((dispatch) => {
        try {
            dispatch(ofSuccess(task(arg)));
        }
        catch (x) {
            dispatch(ofError(x));
        }
    });
}

/**
 * Command to evaluate a simple function and map the success to a message
 * discarding any possible error
 */
export function Cmd_OfFunc_perform(task, arg, ofSuccess) {
    return singleton((dispatch) => {
        try {
            dispatch(ofSuccess(task(arg)));
        }
        catch (matchValue) {
        }
    });
}

/**
 * Command to evaluate a simple function and map the error (in case of exception)
 */
export function Cmd_OfFunc_attempt(task, arg, ofError) {
    return singleton((dispatch) => {
        try {
            task(arg);
        }
        catch (x) {
            dispatch(ofError(x));
        }
    });
}

/**
 * Command that will evaluate an async block and map the result
 * into success or error (of exception)
 */
export function Cmd_OfAsyncWith_either(start, task, arg, ofSuccess, ofError) {
    return singleton((arg_1) => {
        let dispatch;
        start((dispatch = arg_1, singleton_1.Delay(() => singleton_1.TryWith(singleton_1.Delay(() => singleton_1.Bind(task(arg), (_arg) => {
            dispatch(ofSuccess(_arg));
            return singleton_1.Zero();
        })), (_arg_1) => {
            dispatch(ofError(_arg_1));
            return singleton_1.Zero();
        }))));
    });
}

/**
 * Command that will evaluate an async block and map the success
 */
export function Cmd_OfAsyncWith_perform(start, task, arg, ofSuccess) {
    return singleton((arg_1) => {
        start(singleton_1.Delay(() => singleton_1.TryWith(singleton_1.Delay(() => singleton_1.Bind(task(arg), (_arg) => {
            arg_1(ofSuccess(_arg));
            return singleton_1.Zero();
        })), (_arg_1) => {
            return singleton_1.Zero();
        })));
    });
}

/**
 * Command that will evaluate an async block and map the error (of exception)
 */
export function Cmd_OfAsyncWith_attempt(start, task, arg, ofError) {
    return singleton((arg_1) => {
        start(singleton_1.Delay(() => singleton_1.TryWith(singleton_1.Delay(() => singleton_1.Bind(task(arg), (_arg) => {
            return singleton_1.Zero();
        })), (_arg_1) => {
            arg_1(ofError(_arg_1));
            return singleton_1.Zero();
        })));
    });
}

export function Cmd_OfAsync_start(x) {
    Timer_delay(1, (_arg) => {
        startImmediate(x);
    });
}

/**
 * Command to call `promise` block and map the results
 */
export function Cmd_OfPromise_either(task, arg, ofSuccess, ofError) {
    return singleton((dispatch) => {
        try {
            task(arg).then((arg_3) => {
                dispatch(ofSuccess(arg_3));
            }).catch((arg_2) => {
                dispatch(ofError(arg_2));
            });
        }
        catch (x) {
            dispatch(ofError(x));
        }
    });
}

/**
 * Command to call `promise` block and map the success
 */
export function Cmd_OfPromise_perform(task, arg, ofSuccess) {
    return singleton((dispatch) => {
        try {
            task(arg).then((arg_1) => dispatch(ofSuccess(arg_1)));
        }
        catch (matchValue) {
        }
    });
}

/**
 * Command to call `promise` block and map the error
 */
export function Cmd_OfPromise_attempt(task, arg, ofError) {
    return singleton((dispatch) => {
        try {
            task(arg).catch((arg_2) => {
                dispatch(ofError(arg_2));
            });
        }
        catch (x) {
            dispatch(ofError(x));
        }
    });
}

